<template>
  <div>
    <h4 class="is-size-3 has-text-black-bis order-notify-users
      is-flex is-align-items-center is-justify-content-space-between">
      <span class="is-italic has-text-weight-bold line-height">
        Notify Users {{ isDelivery ? '' : `(All Order Updates) (${usersLength.length})`}}
      </span>
      <div class="is-flex is-pulled-right is-align-items-center">
        <div class="is-divider-vertical mt-0"></div>
        <button
          class="button px-0 has-text-black-bis"
          v-tooltip="'Edit'"
          @click="editUsers"
          :disabled="disabled">
          <i class="icon-edit"
            >
          </i>
        </button>
      </div>
    </h4>
    <div class="order-notify-list">
      <div class="column">
        <button
          class="button has-background-black-bis has-text-white taghover"
          v-for="user in notifyUsers"
          :key="user.id"
          :disabled="checkUsers(user)"
        >
          <span class="is-size-5" 
            >
            {{ user.name }}</span>
        </button>
      </div>
    </div>
    <o-modal v-if="isEditable"
      :active="isEditable"
      :canCancel="false"
      class="modal-sm">
      <div class="modal-card">
        <header class="modal-card-head has-background-white">
          <div class="modal-card has-text-dark has-text-weight-bold">Notify Users (All Order Updates) </div>
        </header>
        <section class="modal-card-body is-visible  has-background-white">
          <div class=" column order-notify-list">
            <button
              class="button has-background-black-bis has-text-white taghover"
              v-for="user in notifyUsers"
              :key="user.id"
              @click="removeEmp(user)"
              :disabled="checkUsers(user)"
            >
              <span class="is-size-5">{{ user.name }}</span>
                <i class="icon-removedelete has-text-white" v-if="!checkUsers(user)"></i>
            </button>
          </div>
          <div class="is-divider my-0"></div>
          <div class="column mb-3">
            <div class="columns">
              <div class="column pr-0 pl-0">
                <search-bar :shouldEmit="true" placeholder="Search" @search="getSearchValue"></search-bar>
              </div>
              <div class="is-divider-vertical my-0"></div>
              <div class="column is-narrow">
                <button @click="clear" class="button is-outlined has-text-weight-bold has-background-white" :disabled="disableButton">
                  Clear All
                </button>
              </div>
            </div>
          </div>
          <div class="order-notify-list column">
            <div v-for="(option, key) in userOptions" :key="key">
              <div class="is-italic
                  is-size-4
                  has-text-weight-semibold has-text-grey-dark
                  line-height">
                {{ key }}
            </div>
              <div v-for="user in option" :key="user.id">
                <o-checkbox class="p-0"
                  v-model="user.selected"
                  @update:modelValue="addUsers(user)"
                  :disabled="disableChkBox(user)">
                  <span class="has-text-weight-normal">
                    {{ user.name }}
                  </span>
                </o-checkbox>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end is-align-items-center has-background-white">
          <div class="buttons">
            <button class="button is-outlined has-text-weight-bold" @click="resetAll">
              Cancel
            </button>
            <button class="button has-text-weight-bold has-background-black-bis has-text-white"
              @click="save">
              Apply
            </button>
          </div>
        </footer>
      </div>
    </o-modal>
  </div>
</template>

<script>

import { computed, defineComponent, reactive, toRefs } from 'vue';
import { filter, groupBy, find, isEmpty, map, uniq, cloneDeep, } from 'lodash';
import SearchBar from '@/components/SearchBar.vue';

export default defineComponent({
  components: {
    SearchBar,
  },
  emits: [],
  props: {
    order: {
      type: Object,
      default: () => { },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    projectUsers: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: [],
    },
    isDelivery: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const state = reactive({
      isEditable: false,
      searchText: '',
      notifyUsers: cloneDeep(props.value),
    })

    const editUsers = () => {
      state.isEditable = true;
      state.notifyUsers = cloneDeep(props.value);
    }

     const save = () => {
      state.isEditable = false;
      emit('addNotifier', state.notifyUsers);
      emit('saveUsers');
    }

    const resetAll = () => {
      state.notifyUsers = cloneDeep(props.value);
      state.isEditable = false;
    }

    const getSearchValue = (searchText) => {
      state.searchText = searchText.toLowerCase();
    };

    const addUsers = (user) => {
      user.selected = !user.selected;
      if (!state.notifyUsers.map((i) => i.id).includes(user.id)) {
        state.notifyUsers.push(user);
      } else {
        state.notifyUsers = filter(state.notifyUsers, (i) => i.id !== user.id);
      }
    }

    const disableChkBox = (user) => {
      if (props.order.delivery.owner._id === user._id || props.order.delivery.recipient._id === user._id) return true;
      return false;
    }

    const removeEmp = (user) => {
      state.notifyUsers = filter(state.notifyUsers, (i) => i.id !== user.id);
    }

    const clear = () => {
      state.notifyUsers = filter(state.notifyUsers, (user) => props.order.delivery.owner._id === user._id || props.order.delivery.recipient._id === user._id);
    }

    const usersLength = computed(() => {
      return uniq(map(props.order.delivery.notify, '_id'));
    })

    const userOptions = computed(() => {
      let opts = props.projectUsers;
      if (state.searchText) {
        opts = opts.filter(user => user.name.toLowerCase().includes(state.searchText));
      }
      opts.forEach(u => {
        const selectedUser = find(state.notifyUsers, (nu) => {
          return nu._id === u._id;
        });
        if (!isEmpty(selectedUser)) u.selected = true;
        else u.selected = disableChkBox(u);
      })
      opts = groupBy(opts, 'companyName');
      return opts;
    });

    const checkUsers = (user) => {
      if (props.order.delivery?.owner?._id === user?._id || props.order.delivery?.recipient?._id === user?._id) return true;
      return false;
    }

    const disableButton = computed(() => {
      const defaultUsers = filter(state.notifyUsers, (user) => props.order.delivery.owner._id === user._id || props.order.delivery.recipient._id === user._id);
      if (defaultUsers.length === state.notifyUsers.length) return true;
      return false;
    })

    return {
      ...toRefs(state),
      editUsers,
      resetAll,
      save,
      userOptions,
      addUsers,
      removeEmp,
      clear,
      disableChkBox,
      usersLength,
      checkUsers,
      disableButton,
      getSearchValue,
    }
  }
})

</script>

<style scoped>
  .o-modal__content .modal-card-head {
    border-bottom: none;
    padding: 8px 16px;
  }
  .o-modal__content .modal-card-foot {
    border-top: 1px solid #a6a6a6;
  }
  .is-divider {
    margin: 16px 0 !important;
    border-color: #999999;
  }
  .o-chk {
		justify-content: unset !important;
	}
  .o-chk .o-chk__label span{
    margin-left: 8px;
  }
  .searchbar::before,
  .searchbar::after {
    display: none !important;
  }
  .is-divider-vertical {
    margin-left: 0 !important;
    height: 24px !important;
  }
</style>